import { BottomDrawerModalAnimated } from "@/components/shared/bottom-drawer-modal-animated";
import { Button, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import { generateBookingChatSalesMessage, onChatSales } from "@/lib/chat-sales";
import { Divider } from "@/components/shared/divider";
import type { ServiceName } from "@/types/service";

export function SectionFindBestHelper({
  open,
  onOpenChange,
  name,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  name: ServiceName;
}) {
  return (
    <BottomDrawerModalAnimated
      open={open}
      onOpenChange={onOpenChange}
      footer={
        <Button
          variant="primary"
          color="success"
          size="md"
          fullWidth="full"
          rounded="full"
          onClick={() =>
            onChatSales(true, generateBookingChatSalesMessage(name))
          }
          iconName="whatsappLogo"
          iconColor={"fill-white"}
        >
          Chat Sales
        </Button>
      }
    >
      <View className="flex flex-col gap-2 md:pt-4">
        <Typography variant="label-md">
          Let us find the best helper for your needs!
        </Typography>
        <Typography variant="body-sm" color="foreground-intermediate">
          You have chosen more than one session a week. Let our sales
          specialists understand your needs and find you the best possible
          match!
        </Typography>
      </View>
      <Divider className="mt-4" />
    </BottomDrawerModalAnimated>
  );
}
